export const FILE_STATUS_FILTERS = ['all', 'in_progress', 'success', 'partial', 'error', 'other'];

export const FILE_STATUS_LABELS = {
    all: 'Toate',
    in_progress: 'În lucru',
    success: 'Success',
    partial: 'Parțial',
    error: 'Eroare',
    other: 'Altele'
};

export const MAX_RECENT_ERRORS = 20;

export const clampPercent = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return 0;
    return Math.min(100, Math.max(0, Math.round(numericValue)));
};

export const normalizeFileStatus = (status) => {
    const normalized = (status || '').toString().toLowerCase();

    if (!normalized) return 'other';
    if (normalized.includes('progress') || normalized.includes('running') || normalized.includes('pending')) return 'in_progress';
    if (normalized.includes('partial')) return 'partial';
    if (normalized.includes('error') || normalized.includes('fail')) return 'error';
    if (normalized.includes('success') || normalized.includes('completed') || normalized.includes('done')) return 'success';
    return 'other';
};

export const buildEmptyFileState = (fileName) => ({
    fileName,
    status: 'in_progress',
    progress: 0,
    counts: {},
    errors: [],
    recentRows: [],
    recentErrors: [],
    unmatchedProducts: []
});

export const getDerivedProgress = (payload, fallbackProgress = 0) => {
    if (!payload || typeof payload !== 'object') return clampPercent(fallbackProgress);

    if (Number.isFinite(Number(payload.percent))) {
        return clampPercent(payload.percent);
    }

    const processedRows = Number(payload.processed_rows);
    const totalRows = Number(payload.total_rows);
    if (Number.isFinite(processedRows) && Number.isFinite(totalRows) && totalRows > 0) {
        return clampPercent((processedRows / totalRows) * 100);
    }

    return clampPercent(fallbackProgress);
};
